{
  "avatar": {
    "upload": "Avatar hochladen",
    "change": "Avatar ändern",
    "delete": "Avatar löschen",
    "cropImage": "Bild zuschneiden",
    "zoom": "Zoom",
    "uploadSuccess": "Avatar erfolgreich hochgeladen",
    "uploadError": "Avatar konnte nicht hochgeladen werden",
    "deleteSuccess": "Avatar erfolgreich gelöscht",
    "deleteError": "Avatar konnte nicht gelöscht werden",
    "invalidFile": "Ungültiger Dateityp oder Größe",
    "fileReadError": "Datei konnte nicht gelesen werden"
  },
  "logo": {
    "prepareError": "Logo-Upload konnte nicht vorbereitet werden",
    "uploadSuccess": "Logo erfolgreich hochgeladen",
    "uploadError": "Logo konnte nicht hochgeladen werden",
    "deleteSuccess": "Logo erfolgreich gelöscht",
    "deleteError": "Logo konnte nicht gelöscht werden"
  }
}
